import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Terms: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Terms and Service
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						1. Acceptance of Terms
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						By accessing and using Live Rewards, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do
						not use this service.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						2. Membership
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards membership is subject to the terms outlined in this agreement. Membership can be cancelled at any time. Refunds are subject to our refund policy.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						3. Use License
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Permission is granted to temporarily download one copy of the materials (information or software) on Live Rewards for personal, non-commercial transitory viewing only.
						This is the grant of a license, not a transfer of title, and under this license you may not:
						<br />
						• Modify or copy the materials
						<br />
						• Use the materials for any commercial purpose or for any public display
						<br />
						• Attempt to decompile or reverse engineer any software contained on the site
						<br />• Remove any copyright or other proprietary notations from the materials
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						4. Disclaimer
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						The materials on Live Rewards are provided on an 'as is' basis. Live Rewards makes no warranties, expressed or implied, and hereby disclaims and negates all other
						warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual
						property or other violation of rights.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						5. Limitations
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						In no event shall Live Rewards or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business
						interruption) arising out of the use or inability to use the materials on Live Rewards.
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;
